import { notNullOrUndefined, Site } from "@equiem/web-ng-lib";
import React, { useContext } from "react";
import { CommentButton, LikeButton, RegisterNow } from ".";
import { PublicContentViewQuery } from "../../generated/gateway-client";
import { arrayNotEmpty } from "../../lib/arrayNotEmpty";
import { ContentType } from "../../lib/ContentType";
import { DateTime } from "../../lib/DateTime";
import { PostContent } from "../PostContent";
import { PostContentPage } from "../PostContentPage";

type NewsPost = PublicContentViewQuery["publicContentView"]["node"] & {
  __typename: "NewsPost";
};

interface Props {
  post: NewsPost;
}

export const NewsPost: React.FC<Props> = ({ post }) => {
  const { timezone } = useContext(Site);
  const categories = post.categories.map((cat) => cat.label);

  const actions = (
    <>
      <LikeButton
        shadow="always"
        className="ml-2 mb-2"
        contentType={ContentType.NewsPost}
        contentUuid={post.uuid}
      />
      <CommentButton />
    </>
  );

  const author =
    post.author != null
      ? {
          name: post.author.displayName,
          avatar: post.author.avatar,
        }
      : undefined;

  return (
    <>
      <PostContentPage
        uuid={post.uuid}
        contentType={ContentType.NewsPost}
        title={post.title}
        images={post.images.map((i) => i.url).filter(notNullOrUndefined)}
        author={author}
        publishDate={DateTime.fromMillis(post.publishDate, {
          zone: timezone,
        })}
        commentsEnabled={false}
        enableEntityViewMetric={false}
        pageMetricName="anonymous_page_view"
        categories={categories}
        actions={actions}
        downloads={arrayNotEmpty(post.downloads) ? post.downloads : undefined}
        relatedInformation={
          arrayNotEmpty(post.relatedInfo) ? post.relatedInfo : undefined
        }
      >
        <PostContent html={post.body} className="mt-3" />
      </PostContentPage>
      <RegisterNow />
    </>
  );
};
